var moduleMap = {
	"./useDraft": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_regeneratorRuntime_js-node_modules_babel_runtime_h-8a660a"), __webpack_require__.e("vendors-node_modules_qs_lib_parse_js-node_modules_qs_lib_stringify_js-node_modules_babel_runt-9fe62c"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_tanstack_react-query_tanstack_react-query"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux-_21f50"), __webpack_require__.e("src_hooks_useDraft_useDraft_ts")]).then(function() { return function() { return (__webpack_require__(97147)); }; });
	},
	"./useGetLocations": function() {
		return Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_regeneratorRuntime_js-node_modules_babel_runtime_h-8a660a"), __webpack_require__.e("webpack_sharing_consume_default_tanstack_react-query_tanstack_react-query"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux-_21f50"), __webpack_require__.e("src_hooks_useGetLocations_useGetLocations_ts")]).then(function() { return function() { return (__webpack_require__(50573)); }; });
	},
	"./openMiniViewTransitionDialog": function() {
		return __webpack_require__.e("src_miniView_openMiniViewTransitionDialog_ts").then(function() { return function() { return (__webpack_require__(50834)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});